import { useLocation, matchPath } from 'react-router-dom';
import find from 'lodash/find';
import { routeData } from 'components/Routes';

export const useRoute = () => {
  const location = useLocation();
  return find(routeData, (route) => matchPath(location.pathname, route));
};
